<h2 mat-dialog-title>
  @if (showDueDays) {
    Additional Text Messaging Registration Info Required
  } @else {
    <span class="due-days-title">Attention!</span>
  }
</h2>

<mat-dialog-content>
  @if (showDueDays) {
    <p><strong>Due: {{ matDialogData.dueDate | date : "MMMM d" }} (Number of
        remaining days:
        {{matDialogData.dueDays}})</strong></p>
  }
  @if (showDueDays) {
    <p>
      UPDATE: We've learned that the registration processing is taking longer than was originally communicated to
      EZLynx, and the due date has been moved up to June 9. We strongly urge you to submit your registration information
      as soon as possible to ensure your agency will complete the registration process prior to its messages being
      subjected to blocking.
    </p>
    <p>
      Recent telecom carrier rule changes require additional registration information for your EZLynx Text Messaging
      feature, including your agency’s Employer Identification Number (EIN).
    </p>
    <p>
      EINs identify enterprises as legitimate businesses, and a validation of this information will prevent SMS messages
      from being blocked or flagged as SPAM.
    </p>
    <p>
      Please avoid any disruption to your texting service by <a [routerLink]="['/communication/text-messaging', 'ein']"
         [mat-dialog-close]="true">
        providing the required registration information prior to {{ matDialogData.dueDate | date : "MMMM d" }}</a>
    </p>
  } @else {
    @if (showDeclinedStatus) {
      <p>
        Your Twilio registration has been declined. Please reach out to the EZLynx support team.
      </p>
    } @else {
      <p>
        The 45-day grace period has passed, and the Text Messaging feature for your product has been temporarily disabled.
      </p>
      <p>
        Please re-enable your texting service by <a [routerLink]="['/communication/text-messaging', 'ein']"
           [mat-dialog-close]="true">providing the required
          registration information.</a>
      </p>
    }
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button type="button"
          mat-button
          color="primary"
          [mat-dialog-close]="true">Close</button>
  @if (!showDeclinedStatus) {
    <a mat-button
       [routerLink]="['/communication/text-messaging', 'ein']"
       color="primary"
       [mat-dialog-close]="true">Register</a>
  }
</mat-dialog-actions>